import { useTranslation } from "react-i18next";
import React from "react";
import AbsenceList from "../components/AbsenceList";
import { useSelector } from "react-redux";
import StudentSelectorWrapper from "../../../../components/Peoples/guardian/StudentSelectorWrapper";
import { useEffectiveStudentId } from "../../../../components/Peoples/guardian/hooks/useEffectiveStudentId";
import PageHeader from "../../../../components/Common/PageHeader";

const MyAbsencesPage: React.FC = () => {
  const { t } = useTranslation();
  const user = useSelector((state: any) => state.authSlice.user);
  const studentId = useEffectiveStudentId();

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <PageHeader
          title={t("my_absences")}
          breadcrumbItems={[
            { label: "dashboard", path: "/dashboard" },
            { label: "my_absences", active: true }
          ]}
        />

        <div >
          <div >
            <StudentSelectorWrapper>
              {studentId ? (
                <AbsenceList role={user?.role} studentId={studentId} />
              ) : (
                <p className="text-danger">{t("select_student_first")}</p>
              )}
            </StudentSelectorWrapper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyAbsencesPage;
